export const getCelebritiesData = ({ state }) => state.celebrities.celebritiesData;

export const getSelectedCelebrity = ({ state }) => state.celebrities.selectedCelebrity;
